<p-panel>
  <app-reactive-form-builder
    #formbuilder
    (stableValueChanges)="stableValueChanges($event)"
    (goBack)="goBack()"
    (afterSend)="undefined"
    [form]="form.formFields"
    [serverUrl]="''"
    [id]="reactiveFormRecordId"
    [request]="request"
    [getRequest]="fincasApi.sectoresGET">
  </app-reactive-form-builder>
</p-panel>